module.exports = __webpack_public_path__ + "img/perfect-dive.b8a827f0.png";